var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.645,
    height: 87.645,
    viewBox: "0 0 87.645 87.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-outline",
    transform: "translate(6 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-6 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7197",
    "data-name": "Path 7197",
    d: "M45.822,2A43.822,43.822,0,1,0,89.645,45.822,43.822,43.822,0,0,0,45.822,2Zm0,78.88A35.058,35.058,0,1,1,80.88,45.822,35.058,35.058,0,0,1,45.822,80.88Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7198",
    "data-name": "Path 7198",
    d: "M32.911,24.529H19.764V11.382a4.382,4.382,0,0,0-8.764,0V28.911a4.382,4.382,0,0,0,4.382,4.382H32.911a4.382,4.382,0,0,0,0-8.764Z",
    transform: "translate(28.44 14.911)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.623246e126ee58a8d90f2460c08c0f6b.svg";
export { ForwardRef as ReactComponent };